<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <label>Descrição</label>
          <ChromeSpeechToTextTextarea
            rows="2"
            max-rows="10"
            v-model="description"
          />
        </div>
        <div class="col-md-12 pt-1 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-12 pb-0 text-right">
          <v-btn
            class="btn-save"
            @click="createGeneralInformation"
            :disabled="loading"
          >
            <i class="fas fa-check mr-2"></i>
            ADICIONAR</v-btn
          >
        </div>
      </div>
      <div class="mt-2">
        <div v-if="data.length == 0" class="v-clean p-5 text-center">
          Sem resultados!
        </div>
        <table v-if="data.length > 0" class="table table-sm">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Adicionado por</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in data" :key="key">
              <td>
                {{ item.description ? item.description : "Não informado" }}
              </td>
              <td>
                {{
                  professionalClassCouncilValue({
                    id: item.user_professional_class_council_id,
                    name: item.user_name,
                    value: item.user_professional_class_council_value,
                    cpf: item.user_cpf,
                    office: item.user_office,
                  })
                }}
              </td>
              <td>
                <b-modal
                  size="md"
                  no-close-on-backdrop
                  hide-footer
                  :id="`general_information_care_${key}`"
                  title="INFORMAÇÃO GERAL"
                >
                  <div class="row">
                    <div class="col-md-12 pt-0 pb-0">
                      <label>Descrição</label>
                      <ChromeSpeechToTextTextarea
                        rows="2"
                        max-rows="10"
                        v-model="update_description"
                      />
                    </div>
                    <div class="col-md-12 pt-1 pb-0">
                      <ErrorsMessages :errors="errors" />
                    </div>
                    <div class="col-md-12 pb-0 text-right">
                      <v-btn
                        class="btn-save"
                        @click="updateGeneralInformation(item.id, key)"
                        :disabled="loading"
                        >SALVAR</v-btn
                      >
                    </div>
                  </div>
                </b-modal>
                <v-btn
                  small
                  class="btn-add-down"
                  @click="handleShowModalEdit(item, key)"
                >
                  <i class="fas fa-edit mr-2 text-twenty"></i> EDITAR
                </v-btn>
              </td>
              <td>
                <confirmation-dialog
                  class="ml-1"
                  small
                  message-title="APAGAR?"
                  message-body="Deseja realmente apagar a informação?"
                  open-class="btn-delete"
                  open-left-icon="fa-trash"
                  open-text="APAGAR"
                  @yes="deleteGeneralInformation(item.id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../templates/Components/ErrorsMessages";

import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

import ChromeSpeechToTextTextarea from "../../templates/Components/ChromeSpeechToTextTextarea";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import { formatDate, professionalClassCouncilValue } from "../../lib/format";

export default {
  name: "GeneralInformationCare",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ChromeSpeechToTextTextarea,
  },

  props: {
    group_prescription_care_id: [String, Number],
  },

  data() {
    return {
      loading: false,

      description: "",

      update_description: "",

      errors: [],

      data: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    professionalClassCouncilValue,

    handleShowModalEdit(item, key) {
      this.update_description = item.description;
      this.$bvModal.show(`general_information_care_${key}`);
    },

    retrieve() {
      this.getGeneralInformation();
    },

    async getGeneralInformation() {
      try {
        this.loading = true;

        const { group_prescription_care_id } = this;

        const response = await api.get(
          "/rest-home/prescription/general-information/care",
          {
            params: { group_prescription_care_id },
          }
        );

        const { data } = response.data;

        this.data = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createGeneralInformation() {
      try {
        this.loading = true;

        const { group_prescription_care_id, description } = this;

        let params = {
          group_prescription_care_id,
          description,
        };

        const response = await api.post(
          "/rest-home/prescription/general-information/care",
          params
        );

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");

          this.description = "";

          this.errors = [];

          this.getGeneralInformation();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateGeneralInformation(id, key) {
      try {
        this.loading = true;

        const { update_description } = this;

        let params = {
          id,
          description: update_description,
        };

        const response = await api.put(
          "/rest-home/prescription/general-information/care",
          params
        );

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.description = "";
          this.errors = [];
          this.$bvModal.hide(`general_information_care_${key}`);
          this.getGeneralInformation();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteGeneralInformation(id) {
      try {
        this.loading = true;

        let data = { id };

        const response = await api.delete(
          "/rest-home/prescription/general-information/care",
          {
            data,
          }
        );

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.getGeneralInformation();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
